document.addEventListener('DOMContentLoaded', function () {
    // Desktop Menu Variables
    const openButton = document.getElementById('open_dekstop-menu');
    const closeButton = document.getElementById('close_desktop-menu');
    const desktopMenu = document.querySelector('.desktop_menu');
    const overlay = document.querySelector('.overlay');

    if (openButton && closeButton && desktopMenu && overlay) {
        // Funktion zum Öffnen des Menüs
        openButton.addEventListener('click', function () {
            desktopMenu.classList.add('open');
            overlay.classList.add('is-visible'); // Overlay sichtbar machen
        });

        // Funktion zum Schließen des Menüs
        closeButton.addEventListener('click', function () {
            desktopMenu.classList.remove('open');
            overlay.classList.remove('is-visible'); // Overlay verstecken
        });

        // Menü schließen, wenn außerhalb des Menüs geklickt wird
        document.addEventListener('click', function (event) {
            const isClickInsideMenu = desktopMenu.contains(event.target);
            const isClickOnOpenButton = openButton.contains(event.target);

            if (!isClickInsideMenu && !isClickOnOpenButton) {
                desktopMenu.classList.remove('open');
                overlay.classList.remove('is-visible'); // Overlay verstecken
            }
        });
    } else {
        console.error("Ein erforderliches Element fehlt: open_dekstop-menu, close_desktop-menu, desktop_menu oder overlay.");
    }

    // Toggle Menu Variables
    var toggles = document.querySelectorAll('.menu__toggle');
    var subToggles = document.querySelectorAll('.menu__sub-toggle');

    // Event-Listener zu den Haupt-Toggles hinzufügen
    toggles.forEach(function(toggle) {
        var title = toggle.querySelector('.menu__toggle-title');
        
        if (title) {
            title.addEventListener('click', function() {
                var isOpened = toggle.classList.contains('menu__toggle--opened');
                
                toggles.forEach(function(item) {
                    if (item !== toggle) {
                        item.classList.remove('menu__toggle--opened');
                    }
                });

                if (!isOpened) {
                    toggle.classList.add('menu__toggle--opened');
                } else {
                    toggle.classList.remove('menu__toggle--opened');
                }
            });
        }
    });

    // Event-Listener zu den Sub-Toggles hinzufügen
    subToggles.forEach(function(subToggle) {
        var subTitle = subToggle.querySelector('.menu__sub-toggle-title');
        
        if (subTitle) {
            subTitle.addEventListener('click', function() {
                var isSubOpened = subToggle.classList.contains('menu__sub-toggle--opened');
                
                subToggles.forEach(function(item) {
                    if (item !== subToggle) {
                        item.classList.remove('menu__sub-toggle--opened');
                    }
                });

                if (!isSubOpened) {
                    subToggle.classList.add('menu__sub-toggle--opened');
                } else {
                    subToggle.classList.remove('menu__sub-toggle--opened');
                }
            });
        }
    });
});
